module.exports = __webpack_public_path__ + "static/media/Team 27 - Beacon.e124867b.png";